import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

import Stack from '@mui/joy/Stack';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';

import UserInfo from 'components/UserInfo';
import useAuth from 'hooks/useAuth';
import useUserIdentity from 'hooks/useUserIdentity';
import getIcon from 'utils/getIcon';


function AccountButton({ to, title, icon }: { to: string, title: string, icon: string }) {
    const navigate = useNavigate();

    const Icon = icon ? getIcon(icon) : null;

    return (
        <Button
            startDecorator={Icon ? <Icon /> : null}
            variant="plain"
            color="primary"
            onClick={() => {
                navigate(to);
            }}
        >
            {title}
        </Button>
    );
}

function AccountMainClient() {
    return (
        <Stack>
            <Typography level="title-md">
                Money Related
            </Typography>
            <Typography level="body-sm">
                Credits, Subscriptions, etc.
            </Typography>
            <Stack mt={1} direction="row">
                <AccountButton
                    icon="History"
                    to="/account/credits"
                    title="Credit History" />

                <AccountButton
                    icon="CardMembership"
                    to="/account/subscriptions"
                    title="Subscriptions" />

            </Stack>
        </Stack>

    );
}

const AccountMain = observer(() => {
    const { currentUser } = useAuth();
    const { currentIdentity } = useUserIdentity();
    useEffect(() => {
        document.title = "Account";
    }, []);
    return (
        <Stack
            sx={{
                m: 2,
                display: 'flex',
                flexGrow: 1,
            }}
            spacing={2}
        >
            <UserInfo user={currentUser} />

            <Stack spacing={3}
            >
                <Stack>
                    <Typography level="title-md">
                        Settings and Integrations
                    </Typography>
                    <Typography level="body-sm">
                        Font sizes, colors, calendars and more.
                    </Typography>
                    <Stack mt={1} direction="row">
                        <AccountButton
                            icon="Settings"
                            to="/settings"
                            title="Settings" />
                        <AccountButton
                            icon="EditCalendar"
                            to="/account/calendar/settings"
                            title="Calendar" />
                    </Stack>
                </Stack>
                <Stack>
                    <Typography level="title-md">
                        Your Identity
                    </Typography>
                    <Typography level="body-sm">
                        What information do we share about you?
                    </Typography>
                    <Stack mt={1} direction="row">

                        <AccountButton
                            icon="Fingerprint"
                            to={`/identity/${currentIdentity.key}/edit`}
                            title="Update Contact Info" />
                        <AccountButton
                            icon="PersonPinOutlined"
                            to={`/identity/${currentIdentity.key}`}
                            title="View Your Bio" />

                    </Stack>
                </Stack>

                { currentIdentity.role == 'client' &&
                    <AccountMainClient /> }
            </Stack>


        </Stack>
    );

});



export default AccountMain;
